define('footer/footer',['require','lib/auth/auth','knockout','api-access','i18next','plugins/router','router/router'],function (require) {
    var auth = require('lib/auth/auth');
    var ko = require('knockout');
    var userApi = require('api-access').user;
    var i18n = require('i18next');
    var router = require('plugins/router');
    var routerModel = require('router/router');

    var self = this;

    self.showFooter = ko.observable(false);
    self.feedbackUrl = ko.observable();
    self.showDownloadG2M = ko.observable(true);

    self.showTrainingFooter = ko.computed(function () {
        if (router.activeItem().router && router.activeItem().router.activeInstruction()) {
            return router.activeItem().router.activeInstruction().config.showTrainingFooter;
        }
        return undefined;
    });

    self.trainingFooterHtml = ko.observable(i18n.t('footer.productTraining',
        '<a id="product-training" href="' + i18n.t('web-urls.urls.gototraining.public') + '">', '</a>'));

    var activate = function () {
        /**
         * Do not activate the footer until authentication is checked,
         * and do not show the footer until the other page content composes.
         */
        routerModel.compositionCompletePromise.then(function () {
            self.showFooter(true);
        });

        if (auth.getToken()) {
            userApi.settings().then(function (settings) {
                self.showDownloadG2M(!settings.nativeEndpointDisabled);
            });
            return userApi.me().then(function (meData) {
                self.feedbackUrl(i18n.t('web-urls.urls.collab.feedback', meData.key, meData.email));
            });
        }
        return undefined;
    };

    return {
        activate: activate
    };
});

